<template>
  <svg
    class="custom-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
  >
    <path
      d="M9.7499 7.34115C8.14711 7.34115 6.84732 8.65309 6.84732 10.2718C6.84732 11.8905 8.14707 13.2026 9.7499 13.2026C11.3531 13.2026 12.6525 11.8905 12.6525 10.2718C12.6525 8.65295 11.3531 7.34115 9.7499 7.34115ZM16.1661 3.54372H13.9074C13.6514 2.37481 12.6203 1.5 11.3861 1.5H8.11337C6.87917 1.5 5.84815 2.37481 5.59248 3.54372H3.33378C1.90707 3.54372 0.75 4.71141 0.75 6.15247V13.8912C0.75 15.3322 1.90693 16.5 3.33378 16.5H16.1662C17.5929 16.5 18.75 15.3323 18.75 13.8912L18.7499 6.15213C18.7497 4.71121 17.5928 3.54351 16.166 3.54351L16.1661 3.54372ZM9.7499 14.6086C7.37773 14.6086 5.45465 12.6668 5.45465 10.2714C5.45465 7.87635 7.37784 5.93467 9.7499 5.93467C12.122 5.93467 14.0451 7.87645 14.0451 10.2714C14.0451 12.6668 12.1221 14.6086 9.7499 14.6086ZM16.1931 6.74971C15.7024 6.74971 15.3049 6.34816 15.3049 5.85296C15.3049 5.35772 15.7022 4.9562 16.1931 4.9562C16.6836 4.9562 17.0813 5.35762 17.0813 5.85296C17.0813 6.34819 16.6836 6.74971 16.1931 6.74971Z"
    />
  </svg>
</template>
